export default {
  name: "Temporary Need Information",
  prefix: "E.a",
  sections: [
    {
      fields: [
        {
          code: "E.a.1/E.a.2",
          machine_name: "ea2_soc_title",
          widget: "text",
          label: "SOC Code and Occupation Title",
          hidden: true,
        },
        {
          code: "E.a.1/E.a.2",
          machine_name: "ea1_soc_code",
          widget: "soc",
          label: "SOC Code and Occupation Title",
          field_to_modify: "ea2_soc_title",
          validate: ["required", "noNAs"],
          tooltip: `Enter the six or eight-digit Standard Occupational Classification (SOC) code for the occupation that most clearly describes the work to be performed. For example, the six-digit SOC code for a landscaping worker is 37-3011 (Landscaping and Groundskeeping Workers). The entry in this field must be the same as the SOC code issued by the Department for the employer’s job opportunity on the PWD Form ETA-9141.
          <br><br>Enter the occupational title associated with the SOC. For example, the occupational title associated with SOC code 37-3011.00 is “Landscaping and Groundskeeping Workers.” The entry in this field should be the same as the SOC occupation title used to obtain a PWD on the Form ETA-9141.
          `,
        },
        {
          machine_name: "ea3_pwd_number",
          labelPrefix: "3",
          widget: "text",
          placeholder: "",
          width: 5,
          validate: ["required", "noNAs"],
          maxLength: 18,
          label: 'If "No" is marked in A.5, enter the PWD case number',
          tooltip:
            "If “No” is marked to question A.5, enter the PWD case number obtained from the U.S. Department of Labor for this job opportunity.",
          isVisible: {
            when: "a5_is_emergency",
            is: "NO",
          },
        },
      ],
    },
  ],
};
